import React, { ReactElement } from 'react';
// import { IView } from 'Framework';
import { strings } from 'src/localization';
import { ROHistory, VehicleRec, Customer } from 'src/models';
// import { CustMode } from 'src/enums';
import css from './ViewServiceHistory.module.scss';
import { ScrollBar } from '@framework-controls/core';
import { ISpecsState } from 'src/store/states';
import moment from 'moment';
import 'moment/min/locales.min';
import classNames from 'classnames';

export interface IProps {
    roHistory: ROHistory[];
    vehicles: VehicleRec[];
    custInfo: Customer;
    selectedVehicle: string;
    specData: ISpecsState;
    locale: string;
    theme: string;
}

const ViewServiceHistory = (props: IProps) => {
    const selectedVehicle = props.vehicles[props.selectedVehicle];
    if (!selectedVehicle) {
        return null;
    }

    const processingDate = Date.now();
    let processingUTCDate = moment.utc(processingDate);
    processingUTCDate = processingUTCDate.locale(props.locale);
    const displayDate = processingUTCDate.format('MMMM D, YYYY');
    const prepDate = strings.formatString(strings.ViewHistoryPrepOn, displayDate).toString();
    const vehYear = selectedVehicle.year ? selectedVehicle.year : '';
    let vehMake = selectedVehicle.make ? selectedVehicle.make : '';
    const vehMakeCode = selectedVehicle.makeCode ? selectedVehicle.makeCode : '';
    // Apply Scion logic for vehMake
    if (vehMake === 'Toyota' && vehMakeCode === '2I') {
        vehMake = 'Scion';
    }
    const vehModel = selectedVehicle.model ? selectedVehicle.model : '';
    const reportTitleVeh = selectedVehicle.model ? selectedVehicle.model : vehMake;
    const reportTitle = strings.formatString(strings.YourModelsHistory, reportTitleVeh).toString();
    const displayVehicle = vehYear + ' ' + vehMake + ' ' + vehModel;
    const displayVIN = selectedVehicle.vin;
    let custPhone = props.specData?.serviceDocsSpecs?.servicePhone ?? '';
    const match = custPhone.match(/^(1|)?(\d{3})?(\d{3})(\d{4})$/);

    if (match) {
        const intlCode = match[1] ? match[1] + '-' : '';
        const areaCode = match[2] ? match[2] + '-' : '';
        custPhone = `${intlCode}${areaCode}${match[3]}-${match[4]}`;
    }

    const dateOdoAdvValuesStyles = classNames(
        css.dateOdoAdvValues,
        {
            [css.dateOdoAdvValuesBMW]: props.theme === 'bmw',
            [css.dateOdoAdvValuesFord]: props.theme === 'ford',

        },
    );

    const ROCommRecomValuesStyles = classNames(
        css.ROCommRecomValues,
        {
            [css.ROCommRecomValuesBMW]: props.theme === 'bmw',
            [css.ROCommRecomValuesFord]: props.theme === 'ford',

        },
    );

    const servicesHeaderStyles = classNames(
        css.servicesHeader,
        {
            [css.servicesHeaderBMW]: props.theme === 'bmw',
            [css.servicesHeaderFord]: props.theme === 'ford',

        },
    );

    const jobDescStyles = classNames(
        css.jobDesc,
        {
            [css.jobDescBMW]: props.theme === 'bmw',
            [css.jobDescFord]: props.theme === 'ford',

        },
    );

    const jobCCCValuesStyles = classNames(
        css.jobCCCValues,
        {
            [css.jobCCCValuesBMW]: props.theme === 'bmw',
            [css.jobCCCValuesFord]: props.theme === 'ford',

        },
    );

    const rndOpDescStyles = classNames(
        css.rndOpDesc,
        {
            [css.rndOpDescBMW]: props.theme === 'bmw',
            [css.rndOpDescFord]: props.theme === 'ford',

        },
    );

    const campDescStyles = classNames(
        css.campDesc,
        {
            [css.campDescBMW]: props.theme === 'bmw',
            [css.campDescFord]: props.theme === 'ford',

        },
    );
    const rndCCCValuesStyles = classNames(
        css.rndCCCValues,
        {
            [css.rndCCCValuesBMW]: props.theme === 'bmw',
            [css.rndCCCValuesFord]: props.theme === 'ford',

        },
    );

    const warrOpStyles = classNames(
        css.warrOp,
        {
            [css.warrOpBMW]: props.theme === 'bmw',
            [css.warrOpFord]: props.theme === 'ford',

        },
    );

    // Organize each RO with job details, RND/DE, and Campaign sections
    const histROs: ReactElement[] = [];
    let RNCount = 0;
    if (props.roHistory) {
        props.roHistory.forEach((x, index) => {
            // initialize values for the RO header
            const roNum = x.RO;
            const odometer = x.odometer + ' ' + (props.locale === 'fr-CA' || props.locale === 'en-CA' ? 'km':'mi');
            const advisor = x.advisor;
            const roDateNoFormat = new Date(x.date);
            let processingUTCDate = moment.utc(roDateNoFormat);
            processingUTCDate = processingUTCDate.locale(props.locale);
            const roDateFormat = processingUTCDate.format('MMMM DD, YYYY');
            const comments = x.comments;
            const recom = x.recommendations;
            let commDiv: ReactElement | null = null;
            if (comments) {
                commDiv = <div>
                    <div className={css.lineBreak}></div>
                    <div className={css.ROCommRecom}>
                        <div className={css.ROCommRecomTypes}>{strings.Comments}:</div>
                        <div className={ROCommRecomValuesStyles}>{comments}</div>
                    </div>
                </div>;
            }
            let recomDiv: ReactElement | null = null;
            if (recom) {
                recomDiv = <div>
                    <div className={css.lineBreak}></div>
                    <div className={css.ROCommRecom}>
                        <div className={css.ROCommRecomTypes}>{strings.Recommendations}:</div>
                        <div className={css.ROCommRecomValues}>{recom}</div>
                    </div>
                </div>;
            }
            let commRecom: ReactElement | null = null;
            if (commDiv || recomDiv) {
                commRecom = <div className={css.blockCommRecom}>
                    <div className={css.lineBreak}></div>
                    {commDiv}
                    <div className={css.lineBreak}></div>
                    {recomDiv}
                </div>;
            }
            commRecom = <div className={css.blockCommRecom}>
                {commDiv}
                {recomDiv}
            </div>;
            const ROHeading = <div key={'ROHeading'+index} className={css.ROHeading}>
                <div className={css.repairOrderTitle}>{strings.RepairOrder} {roNum}</div>
                <hr />
                <div className={css.blockDOA}>
                    <div className={css.dateOdoAdvTypes}>
                        <div>{strings.Date}:</div>
                        <div>{strings.Odometer}:</div>
                        <div>{strings.Advisor}:</div>
                    </div>
                    <div className={dateOdoAdvValuesStyles}>
                        <div>{roDateFormat}</div>
                        <div>{odometer}</div>
                        <div>{advisor}</div>
                    </div>
                </div>
                {commRecom}
            </div>;
            // initialize values for Services grid (found in details array)
            const servicesTopBar = <div className={css.servicesTopBar}>
                <div className={css.topBarFirstColName}>
                    {strings.Job}
                </div>
                <div className={css.topBarSecondColName}>
                    {strings.Technicians}
                </div>
            </div>;
            const roJobs: ReactElement[] = [];
            x.detail.forEach((det, index) => {
                const jobDesc = det.opDesc ? det.opDesc:'';
                let jobCWI = det.cwi ? det.cwi:'';
                const jobComplaint = det.complaint ? det.complaint:'';
                const jobCause = det.cause ? det.cause:'';
                const jobCorrection = det.correction ? det.correction:'';
                const jobTechs = det.technicians ?? [];
                let warrSec: ReactElement | null = null;
                if (jobCWI === 'C') {
                    jobCWI = strings.Customer;
                }
                if (jobCWI === 'W') {
                    jobCWI = strings.Warranty;
                    let warrClaimSec: ReactElement | null = null;
                    let warrOpSec: ReactElement | null = null;
                    if (det.warrantyClaimNum && !det.warrantyOp) {
                        warrClaimSec = <div id='warrClaim1'>
                            {strings.WarrClaimNum}:<div className={jobCCCValuesStyles}>{det.warrantyClaimNum}</div>
                        </div>;
                        warrSec = <div className={css.jobCCCTypes}>
                            {warrClaimSec}
                        </div>;
                    }
                    if (det.warrantyOp && !det.warrantyClaimNum) {
                        warrOpSec = <div className={warrOpStyles} id='warrOp1'>{strings.WarrOperation}:
                            <div className={jobCCCValuesStyles}>{det.warrantyOp}</div>
                        </div>;
                        warrSec = <div className={css.jobCCCTypes}>
                            {warrOpSec}
                        </div>;
                    }
                    if (det.warrantyClaimNum && det.warrantyOp) {
                        warrSec = <div className={css.jobCCCTypes}>
                            <div id='warrClaim2'>{strings.WarrClaimNum}:
                                <div className={jobCCCValuesStyles}>{det.warrantyClaimNum}
                                    <div className={warrOpStyles}>{strings.WarrOperation}:
                                        <div className={jobCCCValuesStyles}>{det.warrantyOp}</div>
                                    </div>
                                </div>
                            </div>
                        </div>;
                    }
                }
                if (jobCWI === 'I') {
                    jobCWI = strings.Internal;
                }
                const roJobRow = <div key={'det'+index} className={css.jobGrid}>
                    <div className={css.roJobCell}>
                        <div className={css.jobDescCWI}>
                            <div className={jobDescStyles}>{jobDesc}</div> - <div>{jobCWI}</div>
                        </div>
                        <div className={css.jobCCCCategory}>
                            <div className={css.jobCCCTypes}>
                                <div>{strings.Complaint}:<div className={jobCCCValuesStyles}>{jobComplaint}</div></div>
                                <div>{strings.Cause}:<div className={jobCCCValuesStyles}>{jobCause}</div></div>
                                <div>{strings.Correction}:<div className={jobCCCValuesStyles}>{jobCorrection}</div></div>
                            </div>
                        </div>
                        <div>{warrSec}</div>
                    </div>
                    <div className={css.roTechCell}>
                        {jobTechs.map((tech) => (
                            <span key={tech}>{tech}</span>
                        ))}
                    </div>
                </div>;
                roJobs.push(roJobRow);
            });
            const jobPush = <div>
                {servicesTopBar}
                {roJobs}
            </div>;
            // initialize the RND/DE section of the RO
            const rndTopBar = <div className={css.servicesTopBar}>
                <div className={css.topBarFirstColName}>
                    {strings.Job}
                </div>
            </div>;
            const rndGrid: ReactElement[] = [];
            x.rnddeArray.forEach((rnd, index) => {
                const rndOpDesc = rnd.rndOpDesc ? rnd.rndOpDesc:'';
                const rndComplaint = rnd.rndComplaint ? rnd.rndComplaint:'';
                const rndCause = rnd.rndCause ? rnd.rndCause:'';
                const rndComments = rnd.rndComments ? rnd.rndComments:'';
                const rndRefCode = rnd.rndRefusalCode ? rnd.rndRefusalCode:'';
                let rndRefDueDate: ReactElement | null = null;
                if (rndRefCode === 'RN') {
                    RNCount += 1;
                    rndRefDueDate = <div id={'RefusalCodeDueDate' + RNCount}>
                        {rnd.rndRefusalCodeDueDate ? rnd.rndRefusalCodeDueDate:''}
                    </div>;
                }
                const rndRefCodeDesc = rnd.rndRefusalCodeDesc ? rnd.rndRefusalCodeDesc:'';
                const rndRow = <div key={'rnd'+index} className={css.rndGrid}>
                    <div className={css.rndCell}>
                        <div>
                            <div className={rndOpDescStyles}>{rndOpDesc}</div>
                            <div className={css.rndCCCCategory}>
                                <div className={css.rndCCCTypes}>
                                    <div>{strings.Complaint}:<div className={rndCCCValuesStyles}>{rndComplaint}</div></div>
                                    <div>{strings.Cause}:<div className={rndCCCValuesStyles}>{rndCause}</div></div>
                                    {rndComments ?
                                        <div>{strings.Comments}:<div className={rndCCCValuesStyles}>{rndComments}</div></div>:
                                        null}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={css.rndRefCell}>
                        <div>{rndRefCodeDesc}</div>
                        <div>{rndRefDueDate}</div>
                    </div>
                </div>;
                rndGrid.push(rndRow);
            });
            const rndPush = <div>
                {rndTopBar}
                {rndGrid}
            </div>;
            // initialize the campaign section
            const campaignTopBar = <div className={css.servicesTopBar}>
                <div className={css.topBarFirstColName}>
                    {strings.Description}
                </div>
                <div className={css.topBarSecondColName}>
                    {strings.CampaignNum}
                </div>
            </div>;
            const compaignGrid: ReactElement[] = [];
            x.campaignArray.forEach((camp, index) => {
                const campNum = camp.campNum;
                const campDesc = camp.campDesc;
                const campRow = <div key={'cano'+index} className={css.campGrid}>
                    <div className={css.campCell}>
                        <div>
                            <div className={campDescStyles}>{campDesc}</div>
                        </div>
                    </div>
                    <div className={css.campRefCell}>
                        <div>{campNum}</div>
                    </div>
                </div>;
                compaignGrid.push(campRow);
            });
            const campPush = <div>
                {campaignTopBar}
                {compaignGrid}
            </div>;
            // assign sections to variable and push to histROs
            const pushResult = <div key={'RODisplay'+index}>
                {ROHeading}
                <div className={servicesHeaderStyles}>{strings.Services}</div>
                {jobPush}
                {x.rnddeArray.length > 0 ?
                    <div className={servicesHeaderStyles}>{strings.RNDDEFull}</div>:null}
                {x.rnddeArray.length > 0 ? rndPush:null}
                {x.campaignArray.length > 0 ?<div className={servicesHeaderStyles}>{strings.Campaign}</div>:null}
                {x.campaignArray.length > 0 ? campPush:null}
            </div>;
            histROs.push(pushResult);
        });
    }

    const titleCategoryValuesStyles = classNames(
        css.titleCategoryValues,
        {
            [css.titleCategoryValuesBMW]: props.theme === 'bmw',
            [css.titleCategoryValuesFord]: props.theme === 'ford',

        },
    );

    return (
        <ScrollBar scrollVertical>
            <div className={css.scrollArea}>
                <div className={css.titleCard}>
                    <div className={css.reportTitle}>{reportTitle}</div>
                    <div className={css.titlePrepDate}>{prepDate}</div>
                    <hr className={css.titleHr}/>
                    <div className={css.titleCustName}>{props.custInfo.firstName} {props.custInfo.lastName}</div>
                    <hr className={css.titleHr}/>
                    <div className={css.titleCategory}>
                        <div className={css.titleCategoryTypes}>
                            <div>{strings.Dealership}: </div>
                            <div>{strings.Phone}: </div>
                            <div>{strings.Vehicle}: </div>
                            <div>{strings.VINAcronym}: </div>
                        </div>
                        <div className={titleCategoryValuesStyles}>
                            <div>{props.specData?.serviceDocsSpecs?.dealerName ?? ''}</div>
                            <div>{custPhone}</div>
                            <div>{displayVehicle}</div>
                            <div>{displayVIN}</div>
                        </div>
                    </div>
                </div>
                <div className={css.ROListSection}>
                    {histROs}
                </div>
            </div>
        </ScrollBar>
    );
};

export default ViewServiceHistory;